<template>
  <div class="el-card  pd20 posters">
    <!-- 返回 -->
    <div class="cancel-box">
      <el-button type="info" icon="el-icon-arrow-left" @click="$router.go(-1)" size="medium">返回海报列表</el-button>
    </div>
    <el-divider></el-divider>
    <el-form :rules="rules" ref="form" :model="form" label-width="80px">
      <el-form-item label="海报名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item label="海报类型" prop="type" :label-width="formLabelWidth">
        <el-select v-model="type_show?(form.type===0?'转介分享':'下级招募'):form.type" placeholder="请选择类型" :disabled="is_edit">
          <el-option v-for="(item,index) in type_list" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联课程" prop="course_id" :label-width="formLabelWidth">
        <el-select v-model="form.course_id" placeholder="请选择课程" :disabled="is_edit">
          <el-option v-for="(item,index) in course_list" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!--  -->
      <el-form-item label="海报描述" prop="describe" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.describe"></el-input>
      </el-form-item>
      <!--  -->
      <!-- 背景图 上传图片 -->
      <el-form-item label="上传图片" prop="backimg" :label-width="formLabelWidth">
        <el-upload class="upload-demo" :show-file-list="false" :http-request="uploadImg" :before-upload="beforeAvatarUpload">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <!--  -->
        <el-image class="up-image" :src="form.backimg">
          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div>
          <div slot="error" :style="{height:basis_src?'':'150px','line-height':basis_src?'':'150px'}" class="image-slot error">
            请上传图片...
          </div>
        </el-image>
      </el-form-item>
      <!--  -->
      <el-form-item label="头像位置" prop="headimg" :label-width="formLabelWidth">
        <el-input v-model="form.headimg" placeholder="x,y坐标，以英文,分隔"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item label="头像大小" prop="headsize" :label-width="formLabelWidth">
        <el-input v-model="form.headsize" placeholder="头像大小,单一数值"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item label="昵称位置" prop="nickname" :label-width="formLabelWidth">
        <el-input v-model="form.nickname" placeholder="x,y坐标，以英文,分隔"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item label="昵称字体颜色" prop="nicknamefontcolor" :label-width="formLabelWidth">
        <el-input v-model="form.nicknamefontcolor" placeholder="16进制色值，默认黑色"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item label="昵称字体大小" prop="nicknamefontsize" :label-width="formLabelWidth">
        <el-input v-model="form.nicknamefontsize" placeholder="字体大小"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item label="二维码地址" prop="qrcodeurl" :label-width="formLabelWidth">
        <el-input v-model="form.qrcodeurl" placeholder="生成二维码的链接地址,用户id,请设置${uid}变量,例:https://open.xjy.cn/test/course_details?bid=1&pdk=${uid}&aspx=1"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item label="二维码位置" prop="qrcode" :label-width="formLabelWidth">
        <el-input v-model="form.qrcode" placeholder="x,y坐标，以英文,分隔"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item label="二维码大小" prop="qrcodesize" :label-width="formLabelWidth">
        <el-input v-model="form.qrcodesize" placeholder="单一数值"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item label="状态" prop="status" :label-width="formLabelWidth">
        <el-select v-model="form.status" placeholder="请选择状态">
          <el-option :label="'生效'" :value="0">生效</el-option>
          <el-option :label="'失效'" :value="1">失效</el-option>
        </el-select>
      </el-form-item>
      <!--  -->
      <el-form-item label="排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" placeholder="多个海报有效时，此值控制生成图片的展示顺序,值越小越靠前"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item :label-width="formLabelWidth">
        <el-button type="primary" @click="submitForm('form')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  postersAdd,
  missionCamp,
  upload_image,
  postersEdit
} from "@/api/operating";
export default {
  data() {
      return {
        formLabelWidth: '120px',
        form: {
          name: '',
          course_id: null,
          describe: '',
          backimg: '',
          headimg: '',
          headsize: '',
          nickname: '',
          nicknamefontcolor: '',
          nicknamefontsize: '',
          qrcodeurl: '',
          qrcode: '',
          qrcodesize: ''
        },
        //这是一个验证规则
        rules: {
          course_id: [{
            required: true, //是否必填
            message: '请选择课程', //错误提示信息
            trigger: ['change', 'click'] //检验方式（blur为鼠标点击其他地方，）
          }],
          type: [{
            required: true, //是否必填
            message: '请选择类型', //错误提示信息
            trigger: ['change', 'click'] //检验方式（blur为鼠标点击其他地方，）
          }],
          name: [{
            required: true,
            message: '请输入海报名称',
            trigger: 'blur'
          }],
          // describe:[{
          //     required: true,
          //     message: '请输入海报描述',
          //     trigger: 'blur'
          // }],
          backimg: [{
            required: true,
            message: '请上传背景图',
            trigger: 'blur'
          }],
          // headimg:[{
          //     required: true,
          //     message: '请输入头像坐标',
          //     trigger: 'blur'
          // }],
          // headsize:[{
          //     required: true,
          //     message: '请输入头像大小',
          //     trigger: 'blur'
          // }],
          // nickname:[{
          //     required: true,
          //     message: '请输入昵称坐标',
          //     trigger: 'blur'
          // }],
          // nicknamefontcolor:[{
          //     required: true,
          //     message: '请输入昵称字体颜色',
          //     trigger: 'blur'
          // }],
          // nicknamefontsize:[{
          //     required: true,
          //     message: '请输入昵称字体颜色',
          //     trigger: 'blur'
          // }],
          // qrcodeurl:[{
          //     required: true,
          //     message: '请输入二维码地址',
          //     trigger: 'blur'
          // }],
          // qrcode:[{
          //     required: true,
          //     message: '请输入二维码坐标',
          //     trigger: 'blur'
          // }],
          // qrcodesize:[{
          //     required: true,
          //     message: '请输入二维码大小',
          //     trigger: 'blur'
          // }],
          // status: [{
          //         required: true,//是否必填
          //         message: '请选择状态',//错误提示信息
          //         trigger: ['change','click']//检验方式（blur为鼠标点击其他地方，）
          //     }
          // ],
          // sort:[{
          //     required: true,
          //     message: '请输入排序值',
          //     trigger: 'blur'
          // }]
        },
        is_edit: false,
        course_list: [],
        type_list: [{
          label: '转介分享',
          value: '0'
        }, {
          label: '下级招募',
          value: '100'
        }],
        type_show: false
      }
    },
    methods: {
      beforeAvatarUpload(file) {
        const isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 1;

        if (!file.type === 'image/jpg' || !file.type === 'image/png' || !file.type === 'image/gif') {
          isJPG = false;
          this.$message.error('上传头像图片只能是 jpg/png/gif 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');
        }
        return isJPG && isLt2M;
      },
      uploadImg(param) {
        // FormData 对象
        let form = new FormData();
        // 文件对象
        form.append("image", param.file);
        // 携带当前讲座的id
        form.append("key", this.$route.path);
        form.append("preserve", 1);

        // 上传图片接口
        upload_image(form).then((data) => {
          this.form.backimg = data.image_url;
        });
      },
      // 提交数据
      save() {
        postersAdd(this.form).then((data) => {
          if (data.error > 0) {
            this.$message(data.msg);
            return
          }
          this.$notify({
            title: '成功',
            message: '提交成功！',
            type: 'success'
          });
          this.$router.push('/main/posters_management');
        });
      },
      //
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.save();
          } else {
            this.$message.warning('请检查数据是否为空？');
            return false;
          }
        });
      },
      pullData() {
        // 获得课程列表
        let arr1 = missionCamp();

        let arr2 = postersEdit({
          id: this.$route.query.id
        });


        this.is_edit = this.$route.query.type === 'edit' ? true : false;

        let arr = [arr1];
        if (this.is_edit) {
          arr.push(arr2)
        }

        Promise.all(arr).then((data) => {
          this.course_list = data[0].list;

          //
          if (this.is_edit) {
            this.form = data[1].list;
            this.type_show = true;
          }

        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.posters {
  .el-input,
  .el-textarea {
    width: 800px;
  }
}

.up-image {
  margin: 20px auto auto;
  width: 187.5px;
  text-align: center;
  border-radius: 8px;
  .error {
    border-radius: 8px;
    background-color: rgba($color: #eeeeee, $alpha: .5);
  }
}
</style>
